import React, { useContext } from 'react';
import Overlay from '@/v2/components/atoms/Overlay';
import RegisterInterest from '@/v2/components/layouts/RegisterInterest';
import { StateContext } from '@/v2/state/store';
import { AnalyticsContext } from '@/v2/components/application/Analytics';
import './RegisterInterestOverlay.scss';

const RegisterInterestOverlay = () => {
    const store = useContext(StateContext);
    const { trackEvent } = useContext(AnalyticsContext);
    const { dispatch } = store;
    const { registerInterestOverlayVisible } = store.state;

    const closeRegisterOverlay = () => {
        dispatch({ type: 'HIDE_REGISTER_INTEREST_OVERLAY' });
    };

    const onClose = () => {
        trackEvent('genericClick', {
            locationInPage: 'registerInterest',
            buttonText: 'close',
        });
    };

    return (
        <div className="RegisterInterestOverlay">
            <Overlay open={registerInterestOverlayVisible} onAnimationEndCallback={closeRegisterOverlay} onClose={onClose}>
                <RegisterInterest ctaCallback={closeRegisterOverlay} />
            </Overlay>
        </div>
    );
};

export default RegisterInterestOverlay;
